import React, { useState, useEffect, useRef } from "react";

function useCountUp(target: number) {
    const [value, setValue] = useState(0);
    const ref = useRef<HTMLDivElement>(null);
    const started = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const duration = 1800;
                    const startTime = performance.now();
                    const tick = (now: number) => {
                        const progress = Math.min((now - startTime) / duration, 1);
                        const eased = 1 - Math.pow(1 - progress, 3);
                        setValue(Math.round(target * eased));
                        if (progress < 1) requestAnimationFrame(tick);
                    };
                    requestAnimationFrame(tick);
                }
            },
            { threshold: 0.4 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [target]);

    return { value, ref };
}

const WhyChoose: React.FC = () => {
    const exp  = useCountUp(20);
    const down = useCountUp(70);

    return (
        <section className="why-choose">
            <div className="why-bg" />
            <div className="section-number">03</div>
            <div className="container">
                <span className="section-eyebrow">Why Syslogics</span>
                <h2 className="section-title">Proven Results</h2>

                <div className="stats-row">
                    <div className="stat-block" ref={exp.ref}>
                        <div className="stat-big">
                            {exp.value}<span>+</span>
                        </div>
                        <div className="stat-label">Years Experience</div>
                        <p>Supporting law firms, SMEs, and enterprise clients across diverse industries</p>
                    </div>

                    <div className="stats-divider" />

                    <div className="stat-block" ref={down.ref}>
                        <div className="stat-big">
                            {down.value}<span>%</span>
                        </div>
                        <div className="stat-label">Downtime Reduction</div>
                        <p>Achieved for a Tel Aviv-based law firm through strategic cloud migration</p>
                    </div>
                </div>

                <div className="testimonial-block">
                    <span className="quote-mark">&ldquo;</span>
                    <blockquote>
                        Syslogics transformed our IT from a cost center to a growth enabler.
                        Their proactive approach and deep expertise have been instrumental in
                        our company's digital transformation.
                    </blockquote>
                    <cite>— Senior Partner, Leading Israeli Law Firm</cite>
                </div>
            </div>
        </section>
    );
};

export default WhyChoose;
